module.exports = __webpack_public_path__ + "img/support_prot_mb_4.3de89fc8.jpg";